var React = require('react');

function Win7 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.9016 19.7723H41.384V0L18.9016 3.14061V19.7723Z","fill":"#90B501","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.302 19.7723V3.36377L0.200012 5.7551V19.7723H17.302Z","fill":"#FF720F","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.9016 21.3705V38.0473L41.384 41.184V21.3705H18.9016Z","fill":"#FFBE00","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.302 21.3705H0.200012V35.4381L17.302 37.8242V21.3705Z","fill":"#00A3F9","key":3})]);
}

Win7.defaultProps = {"width":"43","height":"42","viewBox":"0 0 43 42","fill":"none"};

module.exports = Win7;

Win7.default = Win7;
